import {toPascalCase, toFirstLetterUppercase} from '~/src/utilities/helpers/string';
import {ColorScheme} from '~/src/utilities/constants/formats';

/**
 * CSS related utility functions
 */

/**
 * This utility helps create a string of css classnames from a css module object, by either providing
 * classnames as string or in an object containing one or more classname/display-condition pairs
 *
 * @param {object} config key/value pairs of CSS module classnames (classname: hashed)
 * @param  {...any} classes either single classname strings or objects containing key/value pairs of CSS classname and boolean(ish) display condition
 */
const classNames = (config, ...classes) => {
    const hashes = classes.reduce((hashes, className) => {
        if (className) {
            if (typeof className !== 'string') {
                const classes = Object.keys(className).filter((key) => className[key]);
                const hash = classNames(config, ...classes);
                hash && hashes.push(hash);
            } else {
                const hash = config[className];
                hash && hashes.push(hash);
            }
        }

        return hashes;
    }, []);

    return hashes.join(' ');
};

/**
 * This utility returns a classname from a css module object, constructed from a type string. If the constructed classname
 * does not exist, a fallback will be returned.
 *
 * @param {object} config key/value pairs of CSS module classnames (classname: hashed)
 * @param {string} type name of the element that gets styled
 * @param {string} prefix classname prefix (or fallback) to be used. default: element
 */
const classNameByType = (config, type, prefix = 'element') => {
    const componentClass = `${prefix}${toPascalCase(type)}`;

    return classNames(config, {[componentClass]: config[componentClass], [prefix]: !config[componentClass]});
};

const getFormatClassNames = (format) => {
    const names = {};
    if (format) {
        names[format.primaryGrid] = 1;
        if (format.secondaryGrid && format.secondaryGrid !== format.primaryGrid) {
            names[`secondaryGrid${toFirstLetterUppercase(format.secondaryGrid)}`] = 1;
        }
        if (format.colorScheme && format.colorScheme !== ColorScheme.PRIMARY) {
            names[format.colorScheme] = 1;
        }
    }
    return names;
};

export {classNames, classNameByType, getFormatClassNames};
